<template>
    <div style="position: relative; height:100%; display:flex; flex-direction: column; align-items: center;">
        <div @click.stop="showPopMenu" style="display:flex; justify-content: flex-end; align-items: center; text-align:center;width:30px; height:20px;">
            <img :src="require(`@/assets/${imagePath}.png`)" style="width:4px;">
        </div>
    </div>
</template>

<script>
export default {
    name: 'SoccerJoinBookMark',
    props: {
        showPopMenu: {
            type: Function,
            default: () => { }
        },
        imagePath: {
            type: String,
            default: 'option'
        }
    }
}
</script>

<style scoped></style>